module.exports = __webpack_public_path__ + "img/nginx.28fc1534.png";